export default {
  INVALID_TO_ADDRESS: 'Invalid to address',
  INVALID_FROM_ADDRESS: 'Invalid from address',
  INVALID_DATA_HEX: 'Invalid hex string for data',
  NEGATIVE_VALUE: 'negative value'
};
